<template>
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4736_9662)">
      <path
        d="M32 5.83301C17.28 5.83301 5.33331 17.7797 5.33331 32.4997C5.33331 47.2197 17.28 59.1663 32 59.1663C46.72 59.1663 58.6666 47.2197 58.6666 32.4997C58.6666 17.7797 46.72 5.83301 32 5.83301ZM32 53.833C20.24 53.833 10.6666 44.2597 10.6666 32.4997C10.6666 20.7397 20.24 11.1663 32 11.1663C43.76 11.1663 53.3333 20.7397 53.3333 32.4997C53.3333 44.2597 43.76 53.833 32 53.833ZM42.3466 22.6063L26.6666 38.2863L21.6533 33.273C20.6133 32.233 18.9333 32.233 17.8933 33.273C16.8533 34.313 16.8533 35.993 17.8933 37.033L24.8 43.9397C25.84 44.9797 27.52 44.9797 28.56 43.9397L46.1333 26.3663C47.1733 25.3263 47.1733 23.6463 46.1333 22.6063C45.0933 21.5663 43.3866 21.5663 42.3466 22.6063Z"
        fill="#3DD1AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_4736_9662">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
